package io.github.dautovicharis.charts.app.ui.theme

data class Theme(val colors: ThemeColors)
